/* istanbul ignore file */
import React from 'react'
import { Text } from '@adc/ui-adc'

export const MatchBidWinnerInfo = () => {
  return (
    <Text
      className='u-mb-2'
      color='gray'
      data-elm-id='match_the_bid_info'
      size='tiny'
    >
      This is a&nbsp;
      <Text
        as='span'
        color='gray'
        weight='heavy'
        content='Match The Bid'
        data-elm-id='match_the_bid_bold'
      />
      &nbsp;property. We are currently accepting backup offers from other active
      bidders. If they match your winning bid, they'll be able to purchase the
      property if you don't complete the Contract Information Form in the 6-hour
      timeframe.
    </Text>
  )
}
export const MatchBidAvailableInfo = () => {
  return (
    <Text
      className='u-mb-2'
      color='gray'
      data-elm-id='match_the_bid_info'
      size='tiny'
    >
      <Text
        as='span'
        color='gray'
        weight='heavy'
        content='Match The Bid'
        data-elm-id='match_the_bid_bold'
      />
      &nbsp; to get in line before other active bidders submit their backup
      offer!
    </Text>
  )
}
